export const postal_codes = (state) => state.postal_codes;
